import { render, staticRenderFns } from "./planSelectType.vue?vue&type=template&id=13f85a29"
import script from "./planSelectType.vue?vue&type=script&lang=js"
export * from "./planSelectType.vue?vue&type=script&lang=js"
import style0 from "./planSelectType.vue?vue&type=style&index=0&id=13f85a29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports